<script setup lang="ts">
import { computed } from 'vue'
import { formatToInternational } from '@shared/utils'
import Box from '@uiKit/elements/Box.vue'
import { LISTING_VALIDITY_DAYS } from '../../trading'
import SellOutcomeHero from './SellOutcomeHero.vue'
import SellSummaryCard, { type SellSummaryRow } from './SellSummaryCard.vue'
import SellNote from './SellNote.vue'
import { UNDER_REVIEW_NOTE, underReviewSubtitle } from '../constants/sellCopy'
import { formatAmount } from '../utils/sellListingUtils'

// Sell 8 — Under Review (Figma 34433:273398): the listing is submitted and
// its tokens locked while the valuation check runs.

interface Props {
  reference: string
  tokens: number
  pricePerToken: number
}

const props = defineProps<Props>()

const rows = computed<SellSummaryRow[]>(() => [
  { label: 'Listing reference', value: props.reference },
  { label: 'Status', value: 'Under Review', tone: 'warning' },
  { label: 'Tokens listed', value: formatToInternational(props.tokens) },
  { label: 'Price per token', value: formatAmount(props.pricePerToken) },
  { label: 'Validity once live', value: `${LISTING_VALIDITY_DAYS} days` },
])
</script>

<template>
  <Box direction="col" justify="center" gap="14px" grow>
    <SellOutcomeHero
      icon="clock"
      tone="warning"
      title="Listing submitted for review"
      :subtitle="underReviewSubtitle(tokens)"
    />
    <SellSummaryCard eyebrow="LISTING" :rows="rows" />
    <SellNote tone="info" :text="UNDER_REVIEW_NOTE" />
  </Box>
</template>
